import React from 'react';
import './switch.css';
import { IconImageBlackSmall, IconImageWhite, IconPlayBlackSmall, IconPlayWhite } from '../../../assets';
import { TourStoryType } from '../../../types/tourStory';

interface ActionsColumnProps {
  record: TourStoryType;
  handleChangeSwitchVideo: Function;
}

export const SwitchCustom = (props: ActionsColumnProps) => {
  const { record, handleChangeSwitchVideo } = props;
  const checked = record.isSwitchVideo;
  return (
    <label className="switch">
      <input type="checkbox" checked={checked} onChange={() => handleChangeSwitchVideo(record.index)} />
      <span className="slider">
        <div className={`icon-image-on ${checked ? 'hide' : ''}`}>
          <IconImageBlackSmall />
        </div>
        <div className={`icon-play-off ${checked ? 'hide' : ''}`}>
          <IconPlayWhite />
        </div>
        <div className={`icon-play-on ${checked ? '' : 'hide'}`}>
          <IconPlayBlackSmall />
        </div>
        <div className={`icon-image-off ${checked ? '' : 'hide'}`}>
          <IconImageWhite />
        </div>
      </span>
    </label>
  );
};
